module.exports = __webpack_public_path__ + "static/media/subscriptionUser.ce7a11be.svg";